export const APP_VERSION = "1.3.5";
export const APP_DEVELOPER = "SRM International Real Estate LLC";
